import _ from 'lodash';
import PropertyStreetTypeEnum from '~Api/Deal/PropertyStreetTypeEnum';
import { IDictionary } from '~utilities/IDictionary';
import propertyStreetTypeLabels from './PropertyStreetTypeLabels';

// Create a label for equifax street type labels. This is based off the existing street types
// but with any custom ones removed
const equifaxStreetTypeLabels: IDictionary<string> = _.omit(propertyStreetTypeLabels, [
    PropertyStreetTypeEnum.Strait,
]);

export default equifaxStreetTypeLabels;
